import React from "react";
import {
  useUserQuery,
  useUpdateUserMutation,
  UpdateUserMutationVariables,
} from "../../generated/graphql";
import { useToast } from "@chakra-ui/react";
import Loading from "../../components/loading/Loading";
import { Navigate, useNavigate } from "react-router-dom";
import Form from "./Form";

interface Props {
  id: string;
}

const Update: React.VFC<Props> = ({ id }) => {
  const [updateUser] = useUpdateUserMutation();
  const navigation = useNavigate();
  const toast = useToast();

  const { loading, error, data } = useUserQuery({
    variables: {
      where: {
        id,
      },
    },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Navigate to={"/users"} replace />;
  }

  const handleUpdateUser = async (data: UpdateUserMutationVariables) => {
    try {
      await updateUser({
        variables: {
          ...data,
        },
      });

      return toast({
        status: "success",
        title: "Success",
        description: "User updated",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/users");
        },
      });
    } catch (error: any) {
      console.log(error.message);
      return toast({
        status: "error",
        title: "Error",
        description: "An error occured",
        duration: 1000,
      });
    }
  };

  return (
    <Form
      actionType="UPDATE"
      data={data?.user}
      id={id}
      handleUpdateUser={handleUpdateUser}
    />
  );
};

export default Update;
